// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__j-CJr","header":"Layout_header__bJLg+"};